import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ children }) => {
  const { logout } = useAuth();
  const [collapsed, setCollapsed] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const toggleSidebar = () => setCollapsed(prev => !prev);
  const toggleMobileMenu = () => setMobileOpen(prev => !prev);

  return (
    <>
      <button 
        onClick={toggleMobileMenu} 
        style={{ 
          position: 'fixed', 
          top: '10px', 
          left: '10px', 
          backgroundColor: '#4b5563', 
          border: 'none', 
          color: 'white', 
          cursor: 'pointer',
          padding: '8px',
          borderRadius: '4px',
          zIndex: 1001,
        }}
      >
        ☰ {mobileOpen ? 'Close Menu' : 'Open Menu'}
      </button>
      <div style={{ display: 'flex' }}>
        <div style={{ 
          ...styles.sidebar, 
          width: collapsed ? '60px' : '220px',
          transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
          position: window.innerWidth <= 768 ? 'fixed' : 'fixed',
          zIndex: 1000,
          transition: 'transform 0.3s ease'
        }}>
          <h2 style={styles.title}>Search Admin</h2>

          <nav style={styles.nav}>
            <Link to="/" style={styles.link}>{collapsed ? 'D' : 'Dashboard'}</Link>
            <Link to="/users" style={styles.link}>{collapsed ? 'U' : 'User Management'}</Link>
            <Link to="/account" style={styles.link}>{collapsed ? 'A' : 'My Account'}</Link>
            <button onClick={logout} style={styles.button}>{collapsed ? 'L' : 'Logout'}</button>
          </nav>
        </div>
        <div style={{ 
          marginLeft: mobileOpen ? (collapsed ? '60px' : '220px') : '0', 
          padding: '20px', 
          width: '100%', 
          transition: 'margin-left 0.3s' 
        }}>
          {children}
        </div>
      </div>
    </>
  );
};

const styles = {
  sidebar: {
    width: '220px',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: '#1f2937',
    color: '#fff',
    padding: '30px 20px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '40px',
    color: '#facc15',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  link: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '1rem',
    padding: '10px',
    borderRadius: '4px',
    backgroundColor: '#374151',
    textAlign: 'center',
  },
  button: {
    fontSize: '1rem',
    padding: '10px',
    borderRadius: '4px',
    backgroundColor: '#ef4444',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    textAlign: 'center',
  },
};

export default Sidebar;